import { css } from '@emotion/css';
import { Theme } from '@mui/material';

const ratesPopUp = () =>
  css({
    position: 'fixed',
    top: 0,
    right: 0,
    zIndex: 9999,
    pointerEvents: 'none',
    width: '100vw',
    height: '100vh',
  });

const ratesPopUpCard = () =>
  css({
    position: 'absolute',
    width: '300px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    pointerEvents: 'auto',
  });

const ratesPopUpHeader = (theme: Theme) =>
  css({
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    cursor: 'move',
  });

const ratesPopUpHeaderAction = (theme: Theme) =>
  css({
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.contrastText,
    },
  });

const ratesPopUpContent = (theme: Theme) =>
  css({
    display: 'flex',
    alignItems: 'start',
    gap: theme.spacing(1),
    '& .MuiTypography-root': {
      color: theme.palette.primary.light,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.light,
    },
  });

const ratesTableRenderRate = (theme: Theme) =>
  css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(1),
  });

const ratesTableTypography = (theme: Theme) =>
  css({
    color: theme.palette.grey[500],
  });

const ratesTableTypographyMain = (theme: Theme) =>
  css({
    color: theme.palette.primary.main,
  });

const ratesTableDivider = (theme: Theme) =>
  css({
    '&.MuiDivider-root': {
      margin: theme.spacing(0.8, 0),
    },
  });

const getStyles = (theme: Theme) => ({
  ratesPopUp: ratesPopUp(),
  ratesPopUpCard: ratesPopUpCard(),
  ratesPopUpHeader: ratesPopUpHeader(theme),
  ratesPopUpHeaderAction: ratesPopUpHeaderAction(theme),
  ratesPopUpContent: ratesPopUpContent(theme),
  ratesTableRenderRate: ratesTableRenderRate(theme),
  ratesTableTypography: ratesTableTypography(theme),
  ratesTableTypographyMain: ratesTableTypographyMain(theme),
  ratesTableDivider: ratesTableDivider(theme),
});

export default getStyles;
